import { useEffect, useState, useMemo } from "react";
import { useMsal, } from '@azure/msal-react';
import UserApi from "../../api/user/user-api-factory";
import GraphApi from "../../api/graph/graph-api";
import LoadingAnimation from "../../components/loading/loading";
import { UserTile } from "../../components/user/user-tile";
import { NewUserModal } from "../../components/user/new-user-modal";

import './../../pages/properties/property.css'; // TODO Should we share this or move it!?
import { arrayAny } from "../../utils/arrayUtils";

export const ManageUsers = ({ companyName }) => {

    const { instance, inProgress, accounts } = useMsal();

    const [users, setUsers] = useState(null);
    const [shouldFetchUsers, setShouldFetchUsers] = useState(true);
    const [fetchingUsers, setFetchingUsers] = useState(false);
    const [showAddNewUserModal, setShowAddNewUserModal] = useState(false);

    const userApi = useMemo(() => new UserApi(instance, inProgress, accounts, false), [instance, inProgress, accounts]);
    const graphApi = useMemo(() => new GraphApi(instance, inProgress, accounts, false), [instance, inProgress, accounts]);

    useEffect(() => {

        async function fetchData() {
            if (shouldFetchUsers && !fetchingUsers) {
                try {
                    setFetchingUsers(true);
                    const users = await userApi.user('all');
                    if (!!companyName) {
                        setUsers(users.filter(u => u.companyName === companyName));
                    }
                    else if (userApi.hasRole(await userApi.me(), "Application.Developer")) {
                        setUsers(users);
                    }
                    else {
                        console.warn("Should not get here... but filter users by company name if we do. People share links even if not visible on a menu");
                        const graphMe = await graphApi.getMeDetails();
                        setUsers(users.filter(u => u.companyName === graphMe.companyName));
                    }
                    setShouldFetchUsers(false);
                    setFetchingUsers(false);

                } catch (error) {
                    setUsers(null);
                    setShouldFetchUsers(false);
                    setFetchingUsers(false);
                    console.log("An error occurred getting data from the User Data API.", error);
                }
            }
        }
        fetchData();
    }, [userApi, graphApi, companyName, shouldFetchUsers, fetchingUsers]);

    const handleCancelAddUser = () => {
        setShowAddNewUserModal(false);
    };

    const handleAddNewUserSave = newUser => {

    };

    const handleShowAddNewUserModal = () => {
        setShowAddNewUserModal(true);
    };

    return (<div>

        <NewUserModal handleCancel={handleCancelAddUser} handleSave={handleAddNewUserSave} show={showAddNewUserModal} />

        <div>
            <div>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="#/">Home</a></li>
                    <li className="breadcrumb-item active">Users </li>
                </ol>
                <h1 className="page-header mb-0">
                    Manage Users
                </h1>
                <button type="button" className="btn btn-primary mt-2" data-bs-toggle="dropdown">
                    Action&nbsp;&nbsp;<span className="caret"></span>
                </button>
                <div className="dropdown-menu">
                    <a href="#" className="dropdown-item">Action</a>
                    <a href="#" className="dropdown-item">Another action</a>
                    <a href="#" className="dropdown-item">Something else here</a>
                    <div className="dropdown-divider"></div>
                    <a href="#" className="dropdown-item">Separated link</a>
                </div>
            </div>

            <div className="dropdown-menu dropdown-menu-end">
                <div className="dropdown-item" onClick={handleShowAddNewUserModal}><i className="fa fa-plus" />&nbsp;&nbsp;Add User</div>
                {/* <Link to="/form/elements" className="dropdown-item">Another action</Link>
                <Link to="/form/elements" className="dropdown-item">Something else here</Link>
                <div className="dropdown-divider"></div>
                <Link to="/form/elements" className="dropdown-item">Separated link</Link> */}
            </div>

        </div>

        {arrayAny(users) &&
            <div className={'pos-customer bg-gray-100 mt-20px'} >
                <div className="pos-content">
                    <div className="pos-content-container" options={{ suppressScrollX: true }}>
                        <div className="product-row">
                            {users.map(user => {
                                return (
                                    <div key={user.id} className="product-container">
                                        <UserTile user={user} />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        }
        {!arrayAny(users) &&
            <>
                {shouldFetchUsers && fetchingUsers && <LoadingAnimation />}
            </>
        }
    </div >
    );
};